<template>
    <div class="ccpay-temlogin">
        <article class="nav-title" v-show="!this.$flag">
            <mt-header title="用户登錄">
                <!-- <a href="javascript:void(0);" slot="left" @click='goBack'>
                    <mt-button icon="back"></mt-button>
                </a> -->
            </mt-header>
        </article>
        <img src="../../../../static/img/back.png" style="visibility:hidden;" class='gu_nav_title_img_top'
            v-show='this.$flag' @click='goBack'>
        <div class="mobile_content pl-40 pr-40">
            <div class="email_content">
                <h3 class="">
                    <br>{{ page_title }}承兑商平台
                </h3>
                <form action="">
                    <mt-field class="phoneNum phoneNumTull-lv" placeholder="邮箱" type="text" v-model="phone"></mt-field>
                    <!-- <div class='phoneError' ref='phone'></div> -->
                    <mt-field class="passInputWord" placeholder="密码" v-model="password" type="password"> </mt-field>
                    <!-- <div class='passwordError' ref='password'></div> -->
                    <!-- <p class="c9 fz15 mt-15">
                        <a href="javascript:void(0)" class="c9 " @click='goPhoneForgetPasswordOne'>找回密码</a>
                        <a href="javascript:void(0)" class="fr c4a5" @click='goPhoneRegisterOne'>手机注册</a>
                    </p> -->
                    <mt-button class="mt-40" size="large" type="primary" @click.prevent="temlogin"
                        style='letterSpacing:5px;padding-right:0.2rem'>登錄</mt-button>
                    <!-- <mt-button class="mt-20" size="large" type="default" @click.prevent="goPhoneCaptchaLogin">手机验证码登錄</mt-button> -->
                    <mt-button class="mt-20" size="large" type="default" @click.prevent="goReg">注册</mt-button>
                    <p>&nbsp;</p>
                    <p style="text-align: center;color:silver">問題協助請發送郵件至：<a href="mailto:svc.xpay@gmail.com">svc.xpay@gmail.com</a></p>
                </form>
            </div>
        </div>
    </div>
</template>
<script>
import { Indicator } from 'mint-ui';
import { mapActions, mapState } from 'vuex'
// import {getCookie} from '../../../public/index'
// import {setElpCookie} from '../../../public/index'

import { setCookie, setElpCookie, ccpayUser, getCookie, Formatnumbers } from '../../../public/index.js'
export default {
    name: 'phonelogin',
    data() {
        return {
            phone: '',
            password: '',
            page_title: '',
            reg_url: '',
        }
    },
    mounted() {
        if (this.$route.query.type) {
            setElpCookie('elptoken', '', -1, '')
            setCookie('ccpay-token', '', -1)
            ccpayUser('', -1)
            this.$Toast('请您重新登錄')
        }
        // this.removeHtml()
    },
    computed: {
        ...mapState({
            //检测手机号的退後值
            // phoneHaveData:state=>state.phoneStore.phoneHaveData
        })
    },
    created() {
        let _host = window.location.host.toLocaleLowerCase()
        if (_host.indexOf('xpay') > -1) {
            this.page_title = 'XPay'
            this.reg_url = 'https://www.xpay.pro/cn/signup'
        }
        else if (_host.indexOf('otc919') > -1 || _host.indexOf('tw.91') > -1) {
            this.page_title = 'OTC919-'
            this.reg_url = 'https://trade-reg.otc919.com/cn/signup'
        } else {
            this.page_title = 'XPAY-'
            this.reg_url = 'https://www.xpay.pro/cn/signup'
        }

    },
    methods: {
        setCookie,
        getCookie,
        setElpCookie,
        // ...mapActions({
        //     getPhoneHaveAction:'phoneStore/getPhoneHaveAction',//检测手机号是否存在
        //     getPhoneLoginAction:'phoneStore/getPhoneLoginAction',//手机登錄
        //     getUserInfoAction:'phoneStore/getUserInfoAction'//用户个人資訊
        // }),
        goBack() {
            // let url =window.localStorage.getItem('url')
            // this.$router.push({
            //     path:url
            // })
        },
        //先触发清空input值的事件
        removeHtml() {
            document.getElementsByClassName('mint-field-clear')[0].addEventListener('click', (event) => {
                phoneVerification('', this.$refs.phone)
            }),
                document.getElementsByClassName('mint-field-clear')[1].addEventListener('click', (event) => {
                    passwordVerification('', this.$refs.password)
                })
        },
        goReg() {
            //let _that = this;
            // setTimeout(function () {
            // _that.$Toast("注册功能异常，请稍后再试");
            // }, 800);
            //console.log(_that.$router)
            //_that.$router.push({
            //  path: "/regAccount",
            //});
            // return;

            window.location.href = this.reg_url;
        },
        temlogin() {
            if (this.phone == '') {
                this.$Toast('用户不存在或密码错误')
                return
            }
            if (this.password == '') {
                this.$Toast('用户不存在或密码错误')
                return
            }
            Indicator.open();
            this.$axios.post('/v1/login/loginV2S1', {
                "account": this.phone,
                "password": this.password,
                "country_code": "+86"
            }).then(res => {
                Indicator.close();
                if (res.code == 400) {
                    this.$Toast('用户不存在或密码错误')
                    return
                }
                if (res.code == 0) {
                    window.localStorage.setItem('elptoken-phone', this.phone)
                    window.localStorage.setItem('elptoken-password', this.password)
                    setElpCookie('elptoken', res.data.token, 10, res.data.codeType)
                    this.$router.push({
                        path: '/Login'
                    })
                } else {
                    this.$Toast(res.msg)
                    return
                }
            })
            // console.log(1)
        },
        auto() {

        }
        // //手机按键事件
        // phoneInput () {
        //     if(this.$refs.phone.innerHTML!=''){
        //         this.$refs.phone.innerHTML='',
        //         this.$refs.phone.style.borderTop='none'
        //     }
        // },
        // //密码按键事件
        // passwordInput () {
        //     if(this.$refs.password.innerHTML!=''){
        //         this.$refs.password.innerHTML='',
        //         this.$refs.password.style.borderTop='none'
        //     }
        // },
    },
    components: {
    }
}
</script>
<style lang='scss' scoped>
.ccpay-temlogin {
    height: 100vh;
    background: linear-gradient(135deg, #1e3c72 0%, #2a5298 100%);
    position: relative;
    overflow: hidden;

    &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: 
            radial-gradient(circle at 20% 20%, rgba(255,255,255,0.03) 0%, transparent 50%),
            radial-gradient(circle at 80% 80%, rgba(255,255,255,0.02) 0%, transparent 50%),
            linear-gradient(45deg, rgba(255,255,255,0.01) 0%, transparent 100%);
        pointer-events: none;
    }

    .nav-title {
        background: rgba(15, 31, 56, 0.8);
        backdrop-filter: blur(10px);
        border-bottom: 1px solid rgba(255, 255, 255, 0.1);
        
        ::v-deep .mint-header {
            background: transparent;
            color: #ffffff;
            font-weight: 500;
        }
    }
}

.gu_nav_title_img_top {
    position: absolute;
    top: 20px;
    left: 20px;
    z-index: 10;
    filter: brightness(0) invert(1);
    transition: opacity 0.3s ease;

    &:hover {
        opacity: 0.8;
    }
}

.mobile_content {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 100vh;
    padding: 20px;
    box-sizing: border-box;

    .email_content {
        background: rgba(255, 255, 255, 0.98);
        backdrop-filter: blur(10px);
        border-radius: 12px;
        box-shadow: 
            0 8px 32px rgba(30, 60, 114, 0.15),
            0 1px 0px rgba(255, 255, 255, 0.8) inset;
        padding: 48px 40px;
        width: 100%;
        max-width: 420px;
        margin-top: 0;
        position: relative;
        border: 1px solid rgba(255, 255, 255, 0.2);

        &::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            height: 3px;
            background: linear-gradient(90deg, #1e3c72, #2a5298);
            border-radius: 12px 12px 0 0;
        }

        h3 {
            text-align: center;
            color: #1e3c72;
            font-size: 26px;
            font-weight: 700;
            margin-bottom: 32px;
            letter-spacing: -0.5px;
            line-height: 1.2;
        }

        form {
            .phoneNum, .passInputWord {
                margin-bottom: 24px;
                border-radius: 8px;
                overflow: hidden;
                box-shadow: 0 2px 8px rgba(30, 60, 114, 0.08);
                transition: all 0.2s ease;
                border: 1px solid #e1e8f0;
                background: #ffffff;

                &:focus-within {
                    border-color: #2a5298;
                    box-shadow: 0 0 0 3px rgba(42, 82, 152, 0.1);
                }

                ::v-deep .mint-field-core {
                    padding: 16px 18px 16px 24px;
                    font-size: 15px;
                    background: transparent;
                    border: none;
                    color: #2c3e50;
                    font-weight: 400;

                    &::placeholder {
                        color: #8894a0;
                        font-weight: 400;
                    }
                }
            }

            .mt-button {
                border-radius: 8px;
                height: 52px;
                font-size: 15px;
                font-weight: 600;
                letter-spacing: 0.5px;
                transition: all 0.2s ease;
                box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);

                &:hover {
                    transform: translateY(-1px);
                    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
                }

                &:active {
                    transform: translateY(0);
                }

                &.mint-button--primary {
                    background: linear-gradient(135deg, #1e3c72 0%, #2a5298 100%);
                    border: none;
                    color: white;
                    font-weight: 600;

                    &:hover {
                        background: linear-gradient(135deg, #1a3366 0%, #26508a 100%);
                    }
                }

                &.mint-button--default {
                    background: #ffffff;
                    border: 1px solid #d1d9e0;
                    color: #2a5298;
                    font-weight: 500;

                    &:hover {
                        background: #f8fbff;
                        border-color: #2a5298;
                        color: #1e3c72;
                    }
                }
            }

            .mt-40 {
                margin-top: 32px;
            }

            .mt-20 {
                margin-top: 16px;
            }

            p {
                text-align: center;
                color: #6c7b87;
                font-size: 13px;
                line-height: 1.5;
                margin-top: 32px;
                font-weight: 400;

                a {
                    color: #2a5298;
                    text-decoration: none;
                    font-weight: 500;
                    transition: color 0.2s ease;

                    &:hover {
                        color: #1e3c72;
                        text-decoration: underline;
                    }
                }
            }
        }
    }
}

.mint-cell-value {
    width: 100%;
}

// 移动端适配
@media (max-width: 480px) {
    .mobile_content {
        padding: 16px;

        .email_content {
            padding: 32px 24px;
            margin-top: 0;

            h3 {
                font-size: 24px;
                margin-bottom: 28px;
            }

            form {
                .phoneNum, .passInputWord {
                    margin-bottom: 20px;
                    
                    ::v-deep .mint-field-core {
                        padding: 14px 16px 14px 20px;
                        font-size: 14px;
                    }
                }

                .mt-button {
                    height: 48px;
                    font-size: 14px;
                }

                p {
                    font-size: 12px;
                    margin-top: 28px;
                }
            }
        }
    }
}

// 简洁的进入动画
.email_content {
    animation: fadeInUp 0.4s ease-out;
}

@keyframes fadeInUp {
    from {
        opacity: 0;
        transform: translateY(20px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}
</style>






// WEBPACK FOOTER //
// src/components/login/phone/phoneLogin.vue